import AddMessageForContactModal from './AddMessageForContactModal.component';

export default AddMessageForContactModal;
